import { useMemo } from 'react';
import { TYPE_ORDER } from '../constants/layout';
import type { Technique } from '../types';

/** One clip is a guest appearance; two is a body of work worth a row. */
const LISTED_MIN = 2;

/** handle -> their clips, for everyone at or over the bar, ranked by how many.
 *  Derived from the catalog, not written down: a creator appears as soon as
 *  their second clip lands. Shared by the Top Creators page and the face
 *  stack on its Home row. */
export function useRankedCreators(techniques: Technique[]): [string, Technique[]][] {
  return useMemo(() => {
    const m = new Map<string, Technique[]>();
    for (const t of techniques) {
      const a = t.author?.trim();
      if (!a) continue;
      if (!m.has(a)) m.set(a, []);
      m.get(a)!.push(t);
    }
    // Same rule Library uses inside a group — tier, then type, then name — so
    // the two screens read the same. Unsorted, Firestore hands these back in
    // document-id order, which is a random string per clip.
    for (const list of m.values()) {
      list.sort(
        (a, b) =>
          a.tier - b.tier ||
          TYPE_ORDER[a.type] - TYPE_ORDER[b.type] ||
          a.name.localeCompare(b.name),
      );
    }
    return [...m.entries()]
      .filter(([, list]) => list.length >= LISTED_MIN)
      .sort((a, b) => b[1].length - a[1].length);
  }, [techniques]);
}
